module.exports = __webpack_public_path__ + "static/404-b18816909c2104d9715788ef2f44634c.jpg";